<template>
  <div class="quote-form-wrapper">
    <h2 class="form-title">算一算专业托运轿车需要多少钱？</h2>
    <el-form :model="form" :rules="rules" ref="quoteForm" class="quote-form-horizontal">
      <div class="form-row">
        <el-form-item prop="carType" class="form-item-inline" ref="carTypeItem">
          <el-popover
            ref="carTypePopover"
            placement="top"
            width="auto"
            trigger="manual"
            :visible="errors.carType"
            popper-class="warning-popover">
            <div class="error-message">{{ errors.carType }}</div>
            <el-select 
              slot="reference"
              v-model="form.carType" 
              placeholder="请选择车型" 
              filterable
              class="form-select"
              ref="carTypeSelect"
              @change="clearError('carType')"
              @keydown.enter.native="handleCarTypeEnter"
              @visible-change="handleCarTypeVisibleChange">
              <el-option label="轿车" value="轿车"></el-option>
              <el-option label="MPV" value="MPV"></el-option>
              <el-option label="SUV" value="SUV"></el-option>
              <el-option label="跑车" value="跑车"></el-option>
              <el-option label="面包车" value="面包车"></el-option>
              <el-option label="皮卡" value="皮卡"></el-option>
              <el-option label="其它" value="其它"></el-option>
            </el-select>
          </el-popover>
        </el-form-item>
        <el-form-item prop="fromCity" class="form-item-inline" ref="fromCityItem">
          <el-popover
            ref="fromCityPopover"
            placement="top"
            width="auto"
            trigger="manual"
            :visible="errors.fromCity"
            popper-class="warning-popover">
            <div class="error-message">{{ errors.fromCity }}</div>
            <city-picker
              slot="reference"
              v-model="form.fromCity"
              placeholder="请输入始发城市"
              title="选择始发城市"
              :filter-method="(val) => filterCityMethod(val, 'from')"
              @change="clearError('fromCity')">
            </city-picker>
          </el-popover>
        </el-form-item>
        <el-form-item prop="toCity" class="form-item-inline" ref="toCityItem">
          <el-popover
            ref="toCityPopover"
            placement="top"
            width="auto"
            trigger="manual"
            :visible="errors.toCity"
            popper-class="warning-popover">
            <div class="error-message">{{ errors.toCity }}</div>
            <city-picker
              slot="reference"
              v-model="form.toCity"
              placeholder="请输入到达城市"
              title="选择到达城市"
              :filter-method="(val) => filterCityMethod(val, 'to')"
              @change="clearError('toCity')">
            </city-picker>
          </el-popover>
        </el-form-item>
        <el-form-item prop="phone" class="form-item-inline" ref="phoneItem">
          <el-popover
            ref="phonePopover"
            placement="top"
            width="auto"
            trigger="manual"
            :visible="errors.phone"
            popper-class="warning-popover">
            <div class="error-message">{{ errors.phone }}</div>
            <el-input 
              slot="reference"
              v-model="form.phone" 
              placeholder="请填写您的手机号"
              class="form-input"
              @input="clearError('phone')">
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item class="form-item-inline form-item-button">
          <el-button 
            type="primary" 
            @click="submitForm" 
            :loading="loading" 
            class="submit-btn">
            15秒获取报价
          </el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getQuote } from '../api'
import { cities } from '../utils/cities'
import { pinyin } from '../utils/pinyin'
import CityPicker from './CityPicker.vue'

export default {
  name: 'QuoteForm',
  components: {
    CityPicker
  },
  data() {
    return {
      loading: false,
      form: {
        fromCity: '',
        toCity: '',
        carType: '',
        phone: ''
      },
      rules: {
        carType: [
          { required: true, message: '请选择车型', trigger: ['change', 'blur'] }
        ],
        fromCity: [
          { required: true, message: '请选择始发城市', trigger: ['change', 'blur'] }
        ],
        toCity: [
          { required: true, message: '请选择到达城市', trigger: ['change', 'blur'] }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ]
      },
      cities: cities,
      fromCityKeyword: '',
      toCityKeyword: '',
      errors: {
        carType: '',
        fromCity: '',
        toCity: '',
        phone: ''
      },
    }
  },
  computed: {
    filteredFromCities() {
      if (!this.fromCityKeyword) {
        return this.cities
      }
      return this.filterCities(this.fromCityKeyword)
    },
    filteredToCities() {
      if (!this.toCityKeyword) {
        return this.cities
      }
      return this.filterCities(this.toCityKeyword)
    }
  },
  methods: {
    filterCityMethod(keyword, type) {
      // 更新对应选择框的搜索关键词
      if (type === 'from') {
        this.fromCityKeyword = keyword
      } else if (type === 'to') {
        this.toCityKeyword = keyword
      }
      
      // 实时检查精确匹配并自动选中
      // 使用 setTimeout 确保计算属性已更新
      setTimeout(() => {
        if (!keyword) return
        
        // 直接计算过滤结果，不依赖计算属性
        const filteredCities = this.filterCities(keyword)
        
        if (!filteredCities || filteredCities.length === 0) return
        
        // 查找精确匹配
        const exactMatch = filteredCities.find(city => city === keyword)
        
        // 如果只有一个匹配项且是精确匹配，自动选中
        if (filteredCities.length === 1 && exactMatch) {
          const select = this.$refs[`${type}CitySelect`]
          if (!select) return
          
          if (type === 'from') {
            if (this.form.fromCity !== exactMatch) {
              this.form.fromCity = exactMatch
              // 延迟关闭下拉框，让用户看到选中效果
              setTimeout(() => {
                select.blur()
              }, 100)
              this.clearError('fromCity')
            }
          } else {
            if (this.form.toCity !== exactMatch) {
              this.form.toCity = exactMatch
              // 延迟关闭下拉框，让用户看到选中效果
              setTimeout(() => {
                select.blur()
              }, 100)
              this.clearError('toCity')
            }
          }
        }
      }, 50)
    },
    filterCities(keyword) {
      if (!keyword) {
        return this.cities
      }
      
      const lowerKeyword = keyword.toLowerCase()
      return this.cities.filter(city => {
        // 汉字匹配
        if (city.includes(keyword)) {
          return true
        }
        
        // 拼音匹配
        const cityPinyin = pinyin.getFullSpell(city).toLowerCase()
        if (cityPinyin && cityPinyin.includes(lowerKeyword)) {
          return true
        }
        
        // 首字母匹配
        const initials = pinyin.getInitials(city).toLowerCase()
        if (initials && initials.includes(lowerKeyword)) {
          return true
        }
        
        return false
      })
    },
    submitForm() {
      // 先清除所有错误提示
      this.clearAllErrors()
      
      // 验证所有字段，并使用 Popover 显示错误提示
      this.$refs.quoteForm.validate(async (valid, fields) => {
        if (!valid) {
          // 验证失败，使用 Popover 显示错误提示
          this.showValidationErrors(fields)
          // 滚动到第一个错误字段
          this.$nextTick(() => {
            const firstErrorField = this.$el.querySelector('.el-form-item.is-error')
            if (firstErrorField) {
              firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          return false
        }
        
        this.loading = true
        try {
          const res = await getQuote(this.form)
          if (res && res.code === 200) {
            this.$message.success('报价已发送至您的手机，请注意查收！')
            // 重置表单
            this.$refs.quoteForm.resetFields()
            // 重置搜索关键词
            this.fromCityKeyword = ''
            this.toCityKeyword = ''
            this.clearAllErrors()
          } else {
            this.$message.error(res?.message || '提交失败，请稍后重试')
          }
        } catch (error) {
          console.error('提交报价失败:', error)
          const errorMsg = error?.response?.data?.message || error?.message || '提交失败，请稍后重试'
          this.$message.error(errorMsg)
        } finally {
          this.loading = false
        }
      })
    },
    showValidationErrors(fields) {
      // 显示验证错误到对应的 Popover
      if (fields) {
        Object.keys(fields).forEach(field => {
          const fieldErrors = fields[field]
          if (fieldErrors && fieldErrors.length > 0) {
            this.errors[field] = fieldErrors[0].message
            // 显示对应的 Popover
            this.$nextTick(() => {
              const popoverRef = this.$refs[`${field}Popover`]
              if (popoverRef) {
                popoverRef.doShow()
              }
            })
          }
        })
      }
    },
    clearError(field) {
      // 清除指定字段的错误提示
      if (this.errors[field]) {
        this.errors[field] = ''
        const popoverRef = this.$refs[`${field}Popover`]
        if (popoverRef) {
          popoverRef.doClose()
        }
      }
    },
    clearAllErrors() {
      // 清除所有错误提示
      Object.keys(this.errors).forEach(field => {
        this.errors[field] = ''
        const popoverRef = this.$refs[`${field}Popover`]
        if (popoverRef) {
          popoverRef.doClose()
        }
      })
    },
    handleCarTypeEnter(event) {
      // 回车键选中车型
      event.preventDefault()
      const select = this.$refs.carTypeSelect
      if (!select) return
      
      // 获取当前输入值
      const input = select.$el.querySelector('.el-input__inner')
      const inputValue = input ? input.value : ''
      
      if (!inputValue) return
      
      // 车型选项列表
      const carTypes = ['轿车', 'MPV', 'SUV', '跑车', '面包车', '皮卡', '其它']
      
      // 先查找精确匹配
      let matched = carTypes.find(type => type === inputValue)
      
      // 如果没有精确匹配，查找部分匹配
      if (!matched) {
        matched = carTypes.find(type => 
          type.includes(inputValue) || inputValue.includes(type)
        )
      }
      
      if (matched) {
        this.form.carType = matched
        select.blur() // 关闭下拉框
        this.clearError('carType')
      }
    },
    handleCarTypeVisibleChange(visible) {
      // 当下拉框打开时，检查是否有精确匹配
      if (visible) {
        this.$nextTick(() => {
          const select = this.$refs.carTypeSelect
          if (!select) return
          
          const input = select.$el.querySelector('.el-input__inner')
          const inputValue = input ? input.value : ''
          
          if (!inputValue) return
          
          // 车型选项列表
          const carTypes = ['轿车', 'MPV', 'SUV', '跑车', '面包车', '皮卡', '其它']
          
          // 查找精确匹配
          const exactMatch = carTypes.find(type => type === inputValue)
          
          if (exactMatch && this.form.carType !== exactMatch) {
            // 精确匹配，自动选中
            this.form.carType = exactMatch
            select.blur() // 关闭下拉框
            this.clearError('carType')
          }
        })
      }
    },
    handleCityEnter(event, type) {
      // 桌面端回车键处理（由 CityPicker 组件内部处理）
      // 保留此方法以防其他地方调用
    }
  }
}
</script>

<style scoped>
.quote-form-wrapper {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.form-title {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
}

.quote-form-horizontal {
  width: 100%;
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 0;
  flex-wrap: wrap;
  border: 2px solid #75c8fc;
  border-radius: 4px;
  overflow: visible;
}

.form-item-inline {
  flex: 1;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  min-width: 150px;
  position: relative;
}

.form-item-button {
  margin-bottom: 0 !important;
  margin-right: 0 !important;
}

.form-item-inline:not(:last-child):not(.form-item-button)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 60%;
  background-color: #dcdfe6;
  z-index: 1;
}

.form-item-inline >>> .el-form-item__content {
  margin-left: 0 !important;
  margin-bottom: 0 !important;
  line-height: 1;
}

.form-item-button >>> .el-form-item__content {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  display: flex;
}

/* 隐藏默认的表单错误提示 */
.form-item-inline >>> .el-form-item__error {
  display: none;
}

/* Popover 警告样式 - 使用全局样式 */

.form-select,
.form-input {
  width: 100%;
}

.form-select >>> .el-input__inner,
.form-input >>> .el-input__inner {
  height: 48px;
  line-height: 48px;
  border: none;
  border-radius: 0;
  font-size: 14px;
  color: #606266;
  padding: 0 15px;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* 确保移动端可以输入 */
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-tap-highlight-color: transparent;
  /* 移动端确保可以调起键盘 */
  -webkit-appearance: none !important;
  appearance: none !important;
  touch-action: manipulation;
}

.form-select >>> .el-input__inner:hover,
.form-input >>> .el-input__inner:hover {
  background-color: #f5f7fa;
}

.form-select >>> .el-input__inner:focus,
.form-input >>> .el-input__inner:focus {
  background-color: #fff;
  box-shadow: inset 0 0 0 2px #75c8fc;
}

.form-select >>> .el-input.is-focus .el-input__inner,
.form-input >>> .el-input.is-focus .el-input__inner {
  border: none;
}

.form-select >>> .el-input__inner::placeholder,
.form-input >>> .el-input__inner::placeholder {
  color: #c0c4cc;
}

.form-item-button {
  flex: 0 0 auto;
  min-width: 180px;
  display: flex;
  gap: 0;
  margin: 0;
  padding: 0;
}

.form-item-button::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 60%;
  background-color: #dcdfe6;
  z-index: 1;
}

.submit-btn {
  flex: 1;
  width: 100%;
  height: 48px;
  margin: 0 !important;
  padding: 0 !important;
  background: #75c8fc !important;
  border-color: #75c8fc !important;
  color: #fff !important;
  font-size: 24px;
  font-weight: 500;
  border-radius: 0;
  transition: all 0.3s;
}

.consult-btn {
  flex: 1;
  height: 48px;
  background: #67C23A !important;
  border-color: #67C23A !important;
  color: #fff !important;
  font-size: 18px;
  font-weight: 500;
  border-radius: 0;
  transition: all 0.3s;
}

.consult-btn:hover {
  background: #5daf34 !important;
  border-color: #5daf34 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(103, 194, 58, 0.3);
}

.submit-btn:hover {
  background: #5ab8e8 !important;
  border-color: #5ab8e8 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(117, 200, 252, 0.3);
}

.submit-btn:active {
  transform: translateY(0);
}

.submit-btn.is-loading {
  background: #75c8fc !important;
  border-color: #75c8fc !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .form-item-inline {
    min-width: 140px;
  }
  
  .form-item-button {
    min-width: 160px;
  }
}

@media (max-width: 992px) {
  .quote-form-wrapper {
    padding: 25px;
  }
  
  .form-title {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  .form-row {
    gap: 12px;
  }
  
  .form-item-inline {
    min-width: 120px;
  }
  
  .form-item-button {
    min-width: 150px;
    flex-direction: column;
    gap: 8px;
  }
  
  .submit-btn,
  .consult-btn {
    width: 100%;
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .quote-form-wrapper {
    padding: 20px;
  }

  .form-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-item-inline {
    width: 100%;
    min-width: 100%;
  }
  
  .form-item-inline:not(:last-child):not(.form-item-button)::after {
    display: none;
  }
  
  .form-item-inline:not(:last-child) {
    border-bottom: 1px solid #dcdfe6;
  }
  
  .form-item-button {
    width: 100%;
    min-width: 100%;
  }
  
  .form-item-button::before {
    display: none;
  }
  
  .form-item-button {
    border-top: 1px solid #dcdfe6;
  }
  
  .form-select >>> .el-input__inner,
  .form-input >>> .el-input__inner {
    height: 44px;
    line-height: 44px;
    /* 移动端确保可以输入 */
    -webkit-user-select: text !important;
    user-select: text !important;
    -webkit-touch-callout: default;
  }
  
  /* 移动端 select 下拉面板中的输入框 */
  .city-select >>> .el-select-dropdown__item input {
    -webkit-user-select: text !important;
    user-select: text !important;
    -webkit-touch-callout: default;
  }
  
  /* 移动端确保 select 输入框可以调起键盘 */
  .city-select >>> .el-input__inner {
    -webkit-appearance: none !important;
    appearance: none !important;
    touch-action: manipulation !important;
    -webkit-user-select: text !important;
    user-select: text !important;
    -webkit-touch-callout: default !important;
    /* 移除可能阻止输入的样式 */
    pointer-events: auto !important;
  }
  
  /* 当 select 打开时，确保输入框可以输入 */
  .city-select.is-focus >>> .el-input__inner,
  .city-select >>> .el-input.is-focus .el-input__inner {
    -webkit-user-select: text !important;
    user-select: text !important;
    -webkit-touch-callout: default !important;
    pointer-events: auto !important;
  }
  
  .submit-btn {
    height: 44px;
  }
}

@media (max-width: 480px) {
  .quote-form-wrapper {
    padding: 15px;
  }

  .form-title {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .form-row {
    gap: 12px;
  }
  
  .form-select >>> .el-input__inner,
  .form-input >>> .el-input__inner {
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    padding: 0 12px;
  }
  
  .submit-btn {
    height: 40px;
    font-size: 14px;
  }
}
</style>

<style>
/* 移动端 select 下拉面板输入框样式 - 确保可以输入 */
.el-select-dropdown__wrap .el-select-dropdown__item input {
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}

.el-select-dropdown__wrap .el-select-dropdown__item .el-input__inner {
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
}

/* 移动端：确保 select 下拉框中的搜索输入框可以调起键盘 */
.el-select-dropdown .el-select-dropdown__item input,
.el-select-dropdown .el-input__inner {
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  touch-action: manipulation !important;
  pointer-events: auto !important;
  /* 移除 readonly 样式 */
  background-color: transparent !important;
}

/* 确保 select 组件在移动端可以正常输入 */
.el-select.filterable .el-input__inner {
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
  touch-action: manipulation !important;
  pointer-events: auto !important;
}

/* 当 select 打开时，输入框应该可以输入 */
.el-select.is-focus .el-input__inner,
.el-select.filterable.is-focus .el-input__inner {
  -webkit-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
  pointer-events: auto !important;
  /* 确保不是 readonly */
  background-color: #fff !important;
}

/* Popover 警告样式 - 全局样式，确保能覆盖 Element UI 默认样式 */
.warning-popover.el-popover {
  background-color: #e6a23c !important;
  border: 1px solid #e6a23c !important;
  color: #fff !important;
  padding: 6px 10px !important;
  min-width: auto !important;
  max-width: 200px !important;
  font-size: 12px !important;
}

.warning-popover.el-popover * {
  color: #fff !important;
}

.warning-popover.el-popover .el-popover__title {
  color: #fff !important;
}

/* 修复箭头样式 - 只设置内层箭头，外层箭头设为透明 */
.warning-popover.el-popover[x-placement^="top"] .popper__arrow {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-width: 0 !important;
}

.warning-popover.el-popover[x-placement^="top"] .popper__arrow::after {
  border-top-color: #e6a23c !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-width: 0 !important;
}

.warning-popover.el-popover[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: transparent !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-width: 0 !important;
}

.warning-popover.el-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #e6a23c !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-width: 0 !important;
}

.warning-popover.el-popover .error-message {
  color: #fff !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
  margin: 0 !important;
  white-space: nowrap !important;
}
</style>
